import InputPassword from "./password";

export default InputPassword;
